var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"profile-header__background-wrapper",class:(Array.isArray(_vm.data.class) ? _vm.data.class : [_vm.data.class]).concat( [_vm.data.staticClass],
    [{ __empty: !_vm.props.background }] ),style:({ backgroundImage: ("url(" + (_vm.props.background ? _vm.props.background : '/img/empty-profile-bg.png') + ")") })})}
var staticRenderFns = []

export { render, staticRenderFns }